import {h, Fragment} from "preact"
import ProductCard from "./elements/ProductCard"
import { useAppState } from "@nosto/preact"
import useProductGroup from './useProductGroup'
import { useEffect } from "preact/hooks";

export default function Products({ mobileColumns, desktopColumns }) {
    const { response: { products }, loading } = useAppState();
    const { swatchData } = useProductGroup();

    useEffect(() => {
        Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-serp .ns-product',
            productUrlElement: '.ns-serp a.nosto-item-link',
            productHandleAttribute: 'x-nosto-handle',
            priceElement: '.ns-serp .nosto-price',
            listPriceElement: '.ns-serp .nosto-list-price',
        });
    }, [products]);

    return (
        <div
            class="ns-product-grid" 
            data-mobile-col={mobileColumns} 
            data-desktop-col={desktopColumns}
            style={loading ? "opacity: 0.3;" : ""} 
        >
            <ul class="product-grid__content" aria-live="polite">
                {products.hits.map((hit, index) => (
                    <ProductCard 
                        key={hit.productId || index} 
                        product={hit}
                        swatchData={swatchData}
                    />
                ))}
            </ul>
        </div>
    )
}
